export enum ImportationDataTypes {
    Date = 'date',
    DateTime = 'dateTime',
    Number = 'number',
    Text = 'text'
}
